import { PegarProcessosPagBD } from "services/CallAPIs"

export async function fetchProcessos(filterVals) 
{
    try 
    {
        const resp = await PegarProcessosPagBD(filterVals)
        
        if (!resp) 
        {
            return {
                data: [],
                currentPage: 1,
                numPages: 1,
                itemsPerPage: filterVals.itemsPerPage,
                totalItems: 0
            }
        }
        return resp
    } 
    catch (error) 
    {
        console.error("Failed to fetch data: " + error)
        return {
            data: [],
            currentPage: 1,
            numPages: 1,
            itemsPerPage: filterVals.itemsPerPage,
            totalItems: 0
        }
    }
}